import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);
  background: ${({ theme }) => theme.controlsBackground || 'rgba(0, 0, 0, 0.85)'};
  color: ${({ theme }) => theme.controlsText || '#fff'};
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 3000;
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 1rem;
  animation: ${slideIn} 0.3s ease-out;
  border: 2px solid ${({ theme }) => theme.controlsBorder || 'rgba(255, 255, 255, 0.2)'};
  backdrop-filter: blur(10px);
  max-width: 90%;
  text-align: center;
  
  &.exiting {
    animation: ${slideOut} 0.3s ease-in forwards;
  }
  
  @media (max-width: 500px) {
    font-size: 0.9rem;
    padding: 0.8rem 1.2rem;
    top: 4rem;
  }
`;

const Toast = ({ message, duration = 3000, onClose, theme }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <ToastContainer theme={theme}>
      {message}
    </ToastContainer>
  );
};

export default Toast;

